import { render, staticRenderFns } from "./SplitInput.vue?vue&type=template&id=135d1a78&"
import script from "./SplitInput.vue?vue&type=script&lang=js&"
export * from "./SplitInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports